import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
    name: 'dateFormatPipe',
    standalone: false
})
export class SemDateFormatPipePipe extends DatePipe implements PipeTransform {

  transform(value: any, format: string): any {
    return super.transform(value, format);
  }

}
